import React, { useMemo } from "react";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import { useCopyToClipboard } from "usehooks-ts";

import { getMessagesList } from "../../utils/getMessagesList";
import { CopyIcon } from "../icons";
import { SlateEditor } from "../SlateEditor/SlateEditor";
import { NodeTypes } from "../SlateEditor/slateTypes";

interface RequestSidebarMessageProps {
  role: string;
  message: string;
  toolCalls?: string;
}

const RequestSidebarMessage: React.FC<RequestSidebarMessageProps> = ({
  role,
  message,
  toolCalls,
}) => {
  const [_, copy] = useCopyToClipboard();
  const defaultValue = useMemo(() => {
    return getMessagesList({ role, content: message, toolCalls });
  }, [message]);

  const copyToClipboard = () => {
    copy(message)
      .then(() => {
        toast.success("Copied to clipboard!");
      })
      .catch(console.error);
  };

  return (
    <div className="request-sidebar-message">
      <h5>{role}</h5>
      <Button
        variant="link"
        onClick={copyToClipboard}
        data-testid="copy-message"
        className="copy-btn"
      >
        <CopyIcon size={16} />
      </Button>
      <SlateEditor
        defaultValue={defaultValue}
        isLoading={false}
        accessAllowed
        isReadOnly
        inPlayground
      />
    </div>
  );
};

export { RequestSidebarMessage };
